/**
 * Double-chevron used by the operations tree's Expand/Collapse-All control.
 * Ported verbatim from the prototype (agent-studio.html:7503-7504) — deliberately a
 * different glyph from the single-chevron row caret (ChevronUpIcon).
 */
export function ChevronsIcon({ size = 14, direction }: { size?: number; direction: 'down' | 'up' }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {direction === 'down' ? (
        <>
          <polyline points="7 13 12 18 17 13" />
          <polyline points="7 6 12 11 17 6" />
        </>
      ) : (
        <>
          <polyline points="17 11 12 6 7 11" />
          <polyline points="17 18 12 13 7 18" />
        </>
      )}
    </svg>
  )
}
